import { Transfer } from 'antd';
import { Form } from '@bancobarigui/barihaus';

import { useInspectionTypesTransfer } from './useInspectionTypesTransfer';

export function InspectionTypesTransfer() {
  const { inspectionTypes } = useInspectionTypesTransfer();

  return (
    <>
      <style>{`
        .inspection-types-transfer .ant-transfer-list {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
        .inspection-types-transfer .ant-transfer-list-search .ant-input,
        .inspection-types-transfer .ant-transfer-list-search.ant-input-affix-wrapper {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
      `}</style>
      <Form.Item
        name="inspectionTypes"
        valuePropName="targetKeys"
        getValueFromEvent={(targetKeys) => targetKeys}
        rules={[{ required: true, message: 'Informe ao menos um Tipo de Inspecão.' }]}
      >
        <Transfer
          className="inspection-types-transfer"
          listStyle={{
            width: '50%',
            height: 300,
          }}
          dataSource={inspectionTypes}
          render={(item) => item.title ?? ''}
          titles={['Tipos de Inspeção Disponíveis', 'Tipos de Inspeção Selecionados']}
        />
      </Form.Item>
    </>
  );
}
